import {initializeApp} from 'firebase/app'
import {
  getFirestore,
  collection,
  addDoc,
  onSnapshot,
  query,
  orderBy,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore'
import firebaseConfigDev from '../../firebase.json'
import firebaseConfigProd from '../../firebaseProd.json'
import moment from 'moment'

const collections = {
  chat: 'chats',
}

const firebaseConfig = {
  apiKey: `${process.env.REACT_APP_API_FIREBASE_APIKEY}`,
  authDomain: `${process.env.REACT_APP_API_FIREBASE_AUTHDOMAIN}`,
  databaseURL: `${process.env.REACT_APP_API_FIREBASE_DATABASEURL}`,
  projectId: `${process.env.REACT_APP_API_FIREBASE_PROJECTID}`,
  storageBucket: `${process.env.REACT_APP_API_FIREBASE_STORAGEBUCKET}`,
  messagingSenderId: `${process.env.REACT_APP_API_FIREBASE_MESSAGINGSENDERID}`,
  appId: `${process.env.REACT_APP_API_FIREBASE_APPID}`,
  measurementId: `${process.env.REACT_APP_API_FIREBASE_MEASUREMENTID}`,
  // untuk dev measurementId dikomen
}

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)

async function sendMessage({roomId, userId, type = 'negotiation', message}) {
  try {
    
    const chat = {
      roomId,
      userId,
      type,
      message: message.trim(),
      time: moment().format(),
    }

    const sendChat = await addDoc(collection(db, collections.chat, roomId, 'messages'), chat)
    chat.id = sendChat.id

    return chat
  } catch (error) {
    alert('Pesan Gagal Dikirim')
    return false
  }
}

async function updateMessage(roomId, message) {
  try {
    const chat = {
      ...message,
      message: message.message.trim(),
      edited_at: moment().format()
    }
    const model = doc(db, collections.chat, roomId, "messages", message.id);
    await updateDoc(model, chat)
    return chat
  } catch (error) {
    console.log(error)
    alert('Pesan Gagal Diudpate')
    return false
  }
}

async function deleteMessage(roomId, messageId) {
  try {
    const model = doc(db, collections.chat, roomId, "messages", messageId);
    await deleteDoc(model)
    return true
  } catch (error) {
    console.log(error)
    alert('Pesan Gagal Dihapus')
    return false
  }
}

function getMessages(roomId, callback) {
  return onSnapshot(
    query(collection(db, collections.chat, roomId, 'messages'), orderBy('time', 'asc')),
    (querySnapshot) => {
      const messages = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      callback(messages)
    }
  )
}

async function getHistoryMessages(roomId) {
  const q = query(collection(db, collections.chat, roomId, 'messages'), orderBy('time', 'asc'))
  const massage = await getDocs(q)
  return massage.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }))
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getMessages,
  sendMessage,
  updateMessage,
  deleteMessage,
  getHistoryMessages,
}
